"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "rate_info footer-page"
  }, [_vm._m(0), _c("div", {
    staticClass: "flex flex-wrap list_info"
  }, [_c("div", {
    staticClass: "list_item"
  }, [_c("label", [_vm._v("每消费1元赠送：")]), _c("el-input", {
    attrs: {
      clearable: ""
    },
    model: {
      value: _vm.infoData.score_reward,
      callback: function callback($$v) {
        _vm.$set(_vm.infoData, "score_reward", $$v);
      },
      expression: "infoData.score_reward"
    }
  }, [_c("template", {
    slot: "append"
  }, [_vm._v("积分")])], 2)], 1)]), _c("div", {
    staticClass: "page-footer-btns"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("提交")]), _c("el-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("返回")])], 1)]);
};
exports.render = render;
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "label_title"
  }, [_c("p", [_vm._v("基础设置")])]);
}];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;